





























import {Component, Prop, Vue} from 'vue-property-decorator'
import Container from '../proxy/Container.vue'
import Layout from '../proxy/Layout.vue'
import Flex from '../proxy/Flex.vue'
import DateHelper from '@/lib/DateHelper'
import {Rate} from '@/lib/kepler/interfaces'

@Component({
  components: {Flex, Layout, Container},
  name: 'PlanBaseRate',
})
export default class PlanBaseRate extends Vue {
  @Prop() protected plan!: Rate
  @Prop() protected textStyle!: object
  @Prop() protected planCost!: number
  @Prop() protected planDuration!: number

  public parseMinutes(val: number) {
    return DateHelper.parseMinutes(this, val)
  }
}
